{
  "version": 1,
  "asset_id": "8adc34ce-f6c6-4af4-82c0-7e423cb0e98c",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/8adc34ce-f6c6-4af4-82c0-7e423cb0e98c/buyukcekmece-isyeri-5.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/8adc34ce-f6c6-4af4-82c0-7e423cb0e98c/buyukcekmece-isyeri-5.jpg",
  "original_filename": "buyukcekmece-isyeri-5.jpg",
  "size": 642465,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T07:24:25Z"
}
